

import { getProjectList, getProjectOptions, getDepartmentProjectList } from '../services';
export default {
  namespace: 'projectManage',
  state: {
    pagination: {
      pageNum: 1,
      pageSize: 10,
      total: 0, 
    },
    // 工程列表
    projectData:{},
    projectDataCreated:{},
    projectDataJoin:{},
    // 全量工程配置项
    projectConfig:{},
  },
  effects: {
    * getProjectList ({ payload }, { call, put }) {
      const res = yield call(getProjectList, payload);
      const { prjarchSearchType } = payload;
      if(Number(prjarchSearchType) === 1) {
        yield put({
          type: 'update',
          payload: {
            projectData: res.result || {},
          },
        });
      }else if(Number(prjarchSearchType) === 2) {
        yield put({
          type: 'update',
          payload: {
            projectDataCreated: res.result || {},
          },
        });
      }else if(Number(prjarchSearchType) === 3) {
        yield put({
          type: 'update',
          payload: {
            projectDataJoin: res.result || {},
          },
        });
      }
      return res;
    },
    * getDepartmentProjectList ({ payload }, { call, put }) {
      const res = yield call(getDepartmentProjectList, payload);
      yield put({
        type: 'update',
        payload: {
          projectData: res.result || {},
        },
      });
      return res;
    },
    * getProjectOptions ({ payload }, { call, put }) {
      const res = yield call(getProjectOptions, payload);
      yield put({
        type: 'update',
        payload: {
          projectConfig: res.result || {},
        },
      });
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
